import React from 'react';
import styles from './caseHistory.module.scss';
import { Divider, Icon, validIcons } from '@brahma/components';
import type { CaseHistoryProps } from './caseHistory.types';
import { convertEpochTimeToHumanReadbledate } from '@brahma/utils';
import useTimezone from '$hooks/use-timezone';
export const CaseHistoryTimeline = ({
  data
}: CaseHistoryProps) => {
  const timezone = useTimezone();
  return <div className={styles.itemsContainer} data-sentry-component="CaseHistoryTimeline" data-sentry-source-file="caseHistoryTimeline.tsx">
      {data?.map((rootCaseValue: any, rootCaseIndex: number) => {
      return <div className={styles.itemContainer} key={rootCaseValue.title}>
            <div className={styles.topContainer}>
              <div className={styles.leftContainer}>
                <Icon iconName={rootCaseIndex === 0 ? validIcons.currentStepper : validIcons.completeStepper} />
              </div>
              <div className={styles.rightContainer}>
                <div className={styles.heading}>{rootCaseValue.title}</div>
                <div className={styles.subHeading}>
                  {convertEpochTimeToHumanReadbledate(rootCaseValue.subTitle, timezone)}
                </div>
              </div>
            </div>
            {rootCaseValue.subData?.map((item: any, id: number) => {
          return <div className={styles.bottomContainer} key={id}>
                  <div className={styles.leftContainer}>
                    <Icon iconName={validIcons.stepBase} />
                    {rootCaseValue.subData?.length && id === rootCaseValue.subData?.length - 1 ? null : <div className={styles.verticalBar}></div>}
                  </div>
                  <div className={styles.rightContainer}>
                    <div className={styles.heading}>{item.title}</div>
                    <div className={styles.subHeading}>
                      {convertEpochTimeToHumanReadbledate(item.subTitle, timezone)}
                    </div>
                  </div>
                </div>;
        })}
            {data?.length && rootCaseIndex === data?.length - 1 ? null : <Divider className={styles.divider} />}
          </div>;
    })}
    </div>;
};